export enum TransactionLeapDirection {
  NONE = 'none',
  IN = 'in',
  OUT = 'out',
  WITH_IN_BTC = 'with_in_btc',
}
